module.exports = __webpack_public_path__ + "static/img/03_2.35ab0c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/jzjy/03_2.png
// module id = V8uB
// module chunks = 0